'use client';
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { getTranslations } from '@/lib/i18n';

export default function PageHero() {
  const { language } = useLanguage();
  const t = getTranslations(language);

  return (
    <div className="text-center py-6 sm:py-10">
      <div className="inline-flex items-center gap-2 bg-primary/8 border border-primary/20 rounded-full px-4 py-1.5 mb-4">
        <span className="w-2 h-2 rounded-full bg-accent inline-block"></span>
        <span className="text-xs font-semibold text-primary tracking-wider uppercase">
          {t?.heroBadge}
        </span>
      </div>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-foreground tracking-tight mb-3">
        {t?.heroTitle}
        <span className="text-primary">{t?.heroTitle ? ' ' : ''}{t?.heroTitleHighlight}</span>
      </h1>
      <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
        {t?.heroDesc}{' '}
        <span className="font-semibold text-foreground">
          {t?.heroBNB}
        </span>
        . {t?.heroRatesFixed}
      </p>
    </div>
  );
}